import { ImageRatio } from '../Shares/ImageRatio';
export const VipClubBanner: React.FC = () => {
  return <>
      <ImageRatio ratio={397 / 153} src="/assets/vip-club/vip-banner-mobile.svg" alt="vip-club-banner-mobile" hiddenFrom="sm" />
      <ImageRatio ratio={1320 / 343} src="/assets/vip-club/vip-club-banner.svg" alt="vip-club-banner" visibleFrom="sm" />
    </>;
};